<template>
    <div>
        <div class="container">
            <div class="row justify-content-md-center align-items-center" id="merci">
                <div class="col col-lg-10 col-12">
                    <p class="note">&nbsp;</p>
                    <p class="note">
                        Merci {{d_civilite}} {{d_nom}}. 
                    </p>
                    <p class="note"> 
                        Nous vous remercions de l'intérêt porté à notre marque !
                    </p>
                    <p class="note">
                        Nous allons revenir vers vous dans les 48h.
                    </p>
                    <p class="note">
                        L'équipe Rivalis
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["email", "telephone", "nom", "civilite", "date"],
        mounted () {
            this.d_email =this.email
            this.d_telephone =this.telephone
            this.d_nom =this.nom
            this.d_civilite =this.civilite
            this.d_date =this.date
        },
        data () {
            return {
                d_email: false,
                d_telephone: false,
                d_nom: false,
                d_civilite: false,
                d_date: false
            }
        }
    }
</script>

<style lang="less" scoped>
div#merci {
    margin-top:70px;
    p{
        font-size:22px;
    }
    p.note {
        color: #167bc1;
    }
}

div.panel_form {
    box-shadow: 0 0 5px 5px rgba(0,0,0,0.1);
    border-radius: 20px;
    p {
        margin-bottom:40px;
    }
    a#gotosite {
        color: white;
        background: #c9d100;
        padding:15px 20px;
        font-size:22px;
    }
}

span.circle {
    background: #167bc1;
    border-radius: 50%;
    padding: 30px 40px;
    text-align: center;
    color: white;
    font-size: 30px;
    margin-left:39%;
}

</style>